/**
 * @import internal modules
 */
import Layout from '@apps-shared/layout/component';
import Breadcrumb from '@apps-widgets/breadcrumb/component';
import RealTimes from '@apps-widgets/realtimes/component';
import * as Utils from '@root-utils/index';
import * as Lodash from 'lodash';
import * as momentTimeZone from "moment-timezone";
/**
 * @import external modules
 */

import * as React from 'react';
import { pure } from 'recompose';
import * as Scrollbars from 'react-custom-scrollbars';

// component
const Component: React.FunctionComponent<any> = (props: any): any => {
    const { onPlayPause, globalArray, contentFiveClass } = props;
   
    const [dataModale, setDataModale] = React.useState<object>({});

    const timesStamp: any[] = Utils.transformObjectToArray(globalArray);

    const onCallModal = (param: any) => (event: any) => setDataModale(param);

    const onCloseItems = (event: any) => setDataModale({});

    const scrolls = React.createRef<any>();

    React.useEffect(() => {
        scrolls.current.scrollToBottom();
    });

    const TIME_ZONES = 'timesZone'; // times zones objet

    
    return (
        <Layout
            realTime={true}
            onCloseItems={onCloseItems}
            items={contentFiveClass}
            menu={true}
            timerShow={true}
            itemsModal={dataModale}>
            <Breadcrumb
                classnames="screen-width"
                title="Real time"
                level0="real time"
                level1="home"
                realTime={true}
                onPlayPause={onPlayPause}
            />

            <section id="columns" className="with-4-columns">
                <div className="with-all">
                    <Scrollbars.default autoHide={true} ref={scrolls}>
                        {timesStamp &&
                            timesStamp.map((data: any, indexNumber: number) => {
                               
                                const dataFiltered: any[] = data.imageDatas.filter(
                                    (item: any) =>
                                        Number(item.prod.score_classif * 100) >
                                        95,
                                );

                                return (
                                    <div
                                        className="cart-items"
                                        key={indexNumber}>
                                        {!Lodash.isEmpty(dataFiltered) && (
                                            <span className="times">
                                                {Utils.localDateFrSecondFormat(
                                                    momentTimeZone.tz(data.timestampRef,window[TIME_ZONES].TIMESZONE_SERVER).clone().tz(window[TIME_ZONES].TIMESZONE_CLIENT),
                                                )}{' '}
                                            </span>
                                        )}
                                        {!Lodash.isEmpty(dataFiltered) && (
                                            <div className="dashline" />
                                        )}
                                        <div className="cart-content screen-width">
                                            {dataFiltered.map(
                                                (item: any, index: number) => (
                                                    <RealTimes
                                                        items={item}
                                                        key={index}
                                                        onOpenModal={onCallModal(
                                                            item,
                                                        )}
                                                    />
                                                ),
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                    </Scrollbars.default>
                </div>
            </section>
        </Layout>
    );
};

export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/components/@pages/real-time/component.tsx